import { useEffect } from "react";
import { useState } from "react";
import ReactPaginate from "react-paginate";
import { Outlet, useNavigate } from "react-router-dom";
import { generateFormLogic } from "../../../helpers/generate-form-logic";
import { FormAction, FormProps } from "../../../interfaces/form-action-interfaces";
import { useBrandStore } from "../../brand/states/brand.state";
import { Card, CardHeader, CardBody, CardFooter } from "../../forms/components/card";
import FormsComponent from "../../forms/components/forms.component";
import { PageTitle } from "../../forms/components/page-title";
import { Table } from "../../forms/components/table";
import { GridProductData } from "../interfaces/product-result.interface";
import { GetAllGridProductParam } from "../providers/product.provider";
import { useGridProductStore } from "../states/product.state";

export const GridProductLayout = () => {
  return (
    <>
      <PageTitle
        title={'Grid Product'}
        subtitle={'This is an example dashboard created using build-in elements and components.'}
      />
      <Outlet />
    </>
  );
}

export const GridProductScreen = () => {

  const { setGridProductParams, productParams, searchForms, setSearchForms, products, getGridProducts, productModel, onDeleteGridProduct, setSearchFormSelectData } = useGridProductStore();
  const { getBrands, brandsSelectData } = useBrandStore();
  const navigate = useNavigate();

  useEffect(() => {
    getBrands({ page: 0, limit: 1000 });
  }, [])

  useEffect(() => {
    getGridProducts(productParams);
  }, [productParams])

  useEffect(() => {
    if (brandsSelectData.length > 0) {
      setSearchFormSelectData(1, brandsSelectData);
    }
  }, [brandsSelectData]);

  const handlePageClick = (e: any) => {
    const selectedPage = e.selected + 1;
    setGridProductParams({
      ...productParams,
      page: selectedPage
    })
  }

  const onSearch = () => {
    let formData = {}
    for (const v of searchForms) {
      formData = {
        ...formData,
        [v.name]: generateFormLogic(v.type, v?.value ?? '')
      }
    }

    setGridProductParams({
      ...productParams,
      ...formData,
    });
  }

  const handleOnEdit = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, item: GridProductData) => {
    e.preventDefault();
    navigate('form', {
      state: {
        action: FormAction.UPDATE,
        title: 'GridProduct',
        subtitle: 'Form GridProduct',
        id: item.id,
      } as FormProps
    });
  }

  const handleOnView = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, item: GridProductData) => {
    e.preventDefault();
    navigate('form', {
      state: {
        action: FormAction.VIEW,
        title: 'GridProduct',
        subtitle: 'Form GridProduct',
        id: item.id
      } as FormProps
    });
  }

  return (
    <>
      <Card>
        <CardHeader title={"GridProduct Search"} />
        <CardBody>
          <FormsComponent
            forms={searchForms}
            setForms={setSearchForms}
          />
        </CardBody>
        <CardFooter>
          <button
            type="submit"
            className="btn btn-success btn-lg"
            onClick={(e) => {
              e.preventDefault();
              onSearch();
            }}>
            Search
          </button>
        </CardFooter>
      </Card>
      <Card>
        <CardHeader title={'GridProduct'}>
          <div className="btn-actions-pane-right">
            <button
              className="btn btn-outline-success"
              onClick={(e) => {
                e.preventDefault();
                navigate('form', {
                  state: {
                    action: FormAction.CREATE,
                    title: 'GridProduct',
                    subtitle: 'Form GridProduct'
                  } as FormProps
                });
              }}>
              <i className="fa fa-plus"></i>
            </button>
          </div>
        </CardHeader>
        <CardBody clean={true}>
          <Table
            data={products}
            actionButton={(index, item) => {
              let data: GridProductData = item as GridProductData;
              return (
                <div role={'group'} className="btn-group-sm btn-group btn-group-toggle">
                  {
                    <>
                      <button type="button" className="btn btn-primary" onClick={(e) => handleOnView(e, data)}>View</button>
                      <button type="button" className="btn btn-danger" onClick={e => onDeleteGridProduct(data.id, productParams)}>Delete</button>
                      <button type="button" className="btn btn-warning" onClick={e => handleOnEdit(e, data)}>Edit</button>
                    </>
                  }
                </div>
              );
            }}
          />
        </CardBody>
        <CardFooter>
          <ReactPaginate
            previousLabel={"«"}
            nextLabel={"»"}
            breakLabel={"..."}
            breakClassName={"page-item"}
            breakLinkClassName={"page-link"}
            previousClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextClassName={"page-item"}
            nextLinkClassName={"page-link"}
            pageCount={productModel?.data?.meta?.totalPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={10}
            onPageChange={handlePageClick}
            containerClassName={"pagination pagination-sm m-0 float-right"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            activeClassName={"active"}
          />
        </CardFooter>
      </Card>
    </>
  );
}